import { render, staticRenderFns } from "./Havenhuis2.vue?vue&type=template&id=7a70fe0e&"
import script from "./Havenhuis2.vue?vue&type=script&lang=ts&"
export * from "./Havenhuis2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports